module.exports = __webpack_public_path__ + "static/media/implementation_icon.5c959633.png";